/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Děkujeme za registraci!`
};

const da_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Tak for din tilmelding!`
};

const de_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Vielen Dank für Ihre Registrierung!`
};

const en_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Thank you for registering!`
};

const es_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `¡Gracias por registrarte!`
};

const fr_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Merci pour votre inscription !`
};

const hu_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Köszönjük a regisztrációt!`
};

const it_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Grazie per esserti registrato!`
};

const nl_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Bedankt voor je registratie!`
};

const pl_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Dziękujemy za rejestrację!`
};

const pt_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Obrigado por se cadastrar!`
};

const sv_account_thanks_for_registering = /** @type {(inputs: {}) => string} */ () => {
	return `Tack för din registrering!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_thanks_for_registering = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_thanks_for_registering(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_thanks_for_registering", locale)
	if (locale === "cs") return cs_account_thanks_for_registering(inputs)
	if (locale === "da") return da_account_thanks_for_registering(inputs)
	if (locale === "de") return de_account_thanks_for_registering(inputs)
	if (locale === "en") return en_account_thanks_for_registering(inputs)
	if (locale === "es") return es_account_thanks_for_registering(inputs)
	if (locale === "fr") return fr_account_thanks_for_registering(inputs)
	if (locale === "hu") return hu_account_thanks_for_registering(inputs)
	if (locale === "it") return it_account_thanks_for_registering(inputs)
	if (locale === "nl") return nl_account_thanks_for_registering(inputs)
	if (locale === "pl") return pl_account_thanks_for_registering(inputs)
	if (locale === "pt") return pt_account_thanks_for_registering(inputs)
	return sv_account_thanks_for_registering(inputs)
};
export { account_thanks_for_registering as "account.thanks_for_registering" }